module.exports = "/images/register_bg.jpg?6857baa783a5c4ff903aba658bc8aa49";